import callApi from '../../util/apiCaller';

export const FETCH_HISTORY_LOGS = 'FETCH_HISTORY_LOGS';
export const RESET_ALL_HISTORY_LOGS = 'RESET_ALL_HISTORY_LOGS';
export const SHOW_HISTORY_LOGS = 'SHOW_HISTORY_LOGS';

export function resetAllLogs() {
  return (dispatch) => {
    dispatch({
      type: RESET_ALL_HISTORY_LOGS,
    });
    return Promise.resolve();
  };
}

export function loadHistories(opportunityId) {
  return (dispatch) => {
    dispatch({ type: FETCH_HISTORY_LOGS, status: 'loading', opportunityId });
    const p = callApi(`search/opportunities/${opportunityId}/logs`, 'GET');
    p.then(
      (logDetails) => {
        dispatch({
          type: FETCH_HISTORY_LOGS, status: 'loaded', opportunityId, logDetails,
        });
      },
      (error) => {
        dispatch({
          type: FETCH_HISTORY_LOGS, status: 'error', opportunityId, error,
        });
      },
    );
    return p;
  };
}

export function showHistoryLogs(opportunity, logType) {
  return dispatch => dispatch({ type: SHOW_HISTORY_LOGS, opportunity, logType });
}
